import React from "react";
import { useNavigate } from "react-router-dom";
import { useExitUrl } from "@auth/frontend";
import { ArrowLeft } from "lucide-react";

export function NotFound() {
  const navigate = useNavigate();
  const exitUrl = useExitUrl();

  return (
    <div data-testid="not-found" className="flex flex-col items-center justify-center min-h-screen bg-slate-50">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-slate-300">404</h1>
        <p className="mt-4 text-lg text-slate-600">Page non trouvée</p>
        <button
          onClick={() => navigate(exitUrl)}
          className="mt-6 inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-slate-700 bg-white border border-slate-300 rounded-lg hover:bg-slate-50 transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          Retour
        </button>
      </div>
    </div>
  );
}

export default NotFound;
